import RMSOnboardingOverviewContainer from "./RMSOnboardingOverviewContainer";
import RMSOnboardingOverviewStore from "./RMSOnboardingOverviewStore";

export default RMSOnboardingOverviewStore(RMSOnboardingOverviewContainer);